import { TranslationKeys } from '../types';

const colorNames: Record<string, string> = {
  red: 'red',
  blue: 'blue',
  yellow: 'yellow',
  green: 'green',
  white: 'white',
  black: 'black',
  orange: 'orange',
  purple: 'purple',
};

export const en: TranslationKeys = {
  skipToGenerator: 'Skip to generator',
  headerTagline: 'Build your name with LEGO-style brick blocks \u2014 free online generator',
  enterName: 'Enter your name:',
  namePlaceholder: 'TYPE YOUR NAME',
  maxCharacters: 'Maximum 20 characters',
  sizeLabel: 'Size:',
  baseplateLabel: 'Baseplate:',
  piecesNeeded: 'Pieces needed:',
  mainAriaLabel: 'LEGO name builder',
  rootAriaLabel: 'LEGO name generator',
  languageSwitcherLabel: 'Language',
  languageEn: 'English',
  languageEs: 'Spanish',
  inventoryPlate: (size, color) => `${size}x${size} ${colorNames[color] ?? color} plate`,
  inventoryBaseplate: (width, height) => `${width}x${height} baseplate`,
  design3dButton: 'Volume letters',
  design3dBadge: 'Coming soon',
  affiliateBuildTitle: 'Build it in real life!',
  affiliateAmazonCta: 'Buy a brick box on Amazon 🛒',
  affiliateLegoCta: 'Find loose pieces on LEGO Pick a Brick 🧱',
};
